import moment from 'moment';

const transformDate = (input: string) => {
  if (!input) return '';

  const [fullDate, fullTime] = input.split(' ');
  const [year, month, day] = fullDate.split('-').map((num) => num.padStart(2, '0'));
  const [hour, minute] = fullTime.split(':').map((num) => num.padStart(2, '0'));

  return `${day}.${month}.${year} ${hour}:${minute}`;
};

const transformDateMoment = (date: string) => {
  return moment(date, 'YYYY-MM-DD HH:mm:ss.SSSSSSSSS Z ZZ').format('DD.MM.YYYY HH:mm');
};

export { transformDate, transformDateMoment };
